import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { ProsAndCons } from '../../../ProsAndCons';

export type SMBProsAndConsTable = StructuredContentDocument<{
  pros?: string[];
  cons?: string[];
}>;

export function SMBProsAndConsTable({ props }: SMBProsAndConsTable) {
  return (
    <Box sx={{ padding: 3 }}>
      <ProsAndCons prosList={props.pros} consList={props.cons} />
    </Box>
  );
}
